<h3>
    <!--{{"transcript.transcript"|translate}}-->
    {{getTitle()}}
    {{"transcript.of"|translate}} <a ng-click="onTranscriptClick()">{{transcript.Workflow.UniqueRegistrationNumber}} {{transcript.Workflow.Title}}</a>
    {{"transcript.for"|translate}} <a ng-click="onTagClick()" ng-bind-html="htmlTag(localize(transcript.Tag.Name))"></a>
</h3>

<div ng-if="transcript.TranscriptResponses.length == 0">
    <span>Denna pappershantering saknar mottagare</span>
</div>

<div ng-if="transcript.TranscriptResponses.length > 0">
    <ol>
        <li ng-repeat="response in transcript.TranscriptResponses">
            <h3 class="transcript-heading">
                {{localize(response.Recipient.Name)}}
            </h3>
            <div class="transcript-description">
                {{localize(response.Recipient.Description)}}
            </div>
            <div c-select options="response.options" selected-option="response.option"></div>
        </li>
    </ol>
</div>
